module.exports = __webpack_public_path__ + "static/media/friction.f6cb4533.svg";